<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <label>Material</label>
                  <input
                    type="text"
                    id="material"
                    class="form-control"
                    v-model="material.nome"
                    disabled
                  />
                </div>
                <div class="col-md-6">
                  <label>Código de barras</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="material.codigo"
                    disabled
                  />
                </div>
                <div class="col-md-2 form-group">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      autocomplete="new-password"
                      v-model="material.dispensavel"
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch3"
                      disabled
                    />
                    <label class="custom-control-label" for="customSwitch3"
                      ><b
                        :class="
                          material.dispensavel
                            ? 'text-primary'
                            : 'text-secondary'
                        "
                        disabled
                        >Dispensável</b
                      ></label
                    >
                  </div>
                </div>
                <div class="col-md-2 form-group">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      autocomplete="new-password"
                      v-model="material.controlado"
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch1"
                      disabled
                    />
                    <label class="custom-control-label" for="customSwitch1"
                      ><b
                        :class="
                          material.controlado
                            ? 'text-primary'
                            : 'text-secondary'
                        "
                        disabled
                        >Controlado</b
                      ></label
                    >
                  </div>
                </div>
                <div class="col-md-2 form-group">
                  <div class="custom-control custom-switch mt-1 pt-1">
                    <input
                      autocomplete="new-password"
                      v-model="material.portaria"
                      placeholder=""
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch2"
                      disabled
                    />
                    <label class="custom-control-label" for="customSwitch2"
                      ><b
                        :class="
                          material.portaria ? 'text-primary' : 'text-secondary'
                        "
                        disabled
                        >Portaria 344/98</b
                      ></label
                    >
                  </div>
                </div>
                <div class="col-md-2">
                  <label>Período dispensável</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="material.periodo_dispensavel"
                    disabled
                  />
                </div>
                <div class="col-md-2">
                  <label>Estoque mínimo</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="material.estoque_minimo"
                    disabled
                  />
                </div>
                <div class="col-md-4">
                  <label>Unidade dispensada</label>
                  <v-select
                    :options="unidadeMateriais"
                    :reduce="(unidadeMateriais) => unidadeMateriais.id"
                    :label="'label_unidade'"
                    v-model="material.unidade_dispensada"
                    disabled
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Tipo Receita</label>
                  <v-select
                    :options="tipo_receitas"
                    :searchble="true"
                    :reduce="(tipo_receitas) => tipo_receitas.id"
                    :label="'label_tipo_receita'"
                    v-model="material.tipo_receita_id"
                    disabled
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Grupo</label>
                  <v-select
                    :options="grupos"
                    :reduce="(grupos) => grupos.id"
                    :label="'nome'"
                    v-model="material.grupo_id"
                    @input="getSubGrupos()"
                    disabled
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Sub Grupo</label>
                  <v-select
                    :options="sub_grupos"
                    :reduce="(sub_grupos) => sub_grupos.id"
                    :label="'nome'"
                    v-model="material.subgrupo_id"
                    disabled
                    @input="getFamilias()"
                  ></v-select>
                </div>
                <div class="col-md-4">
                  <label>Família</label>
                  <v-select
                    :options="familias"
                    :reduce="(familias) => familias.id"
                    :label="'nome'"
                    v-model="material.familia_id"
                    @input="getGrupos()"
                    disabled
                  ></v-select>
                </div>
                <div class="col-md-6">
                  <label>Fabricante</label>
                  <v-select
                    :options="fabricantes"
                    :reduce="(fabricantes) => fabricantes.id"
                    :label="'nome_fantasia'"
                    v-model="material.fabricante_id"
                    disabled
                  ></v-select>
                </div>
                <div class="col-md-6">
                  <label>Fornecedor</label>
                  <v-select
                    :options="fornecedores"
                    :reduce="(fornecedores) => fornecedores.id"
                    :label="'nome_fantasia'"
                    v-model="material.fornecedor_id"
                    disabled
                  ></v-select>
                </div>
              </div>
              <hr />
              <div class="col-md-12">
                <div class="card-title">Detalhes do Estoque</div>
              </div>
              <div class="col-md-12 p-1" style="overflow-x: auto">
                <table class="table table-bordered">
                  <thead class="text-center">
                    <th>Material</th>
                    <th>Fabricante</th>
                    <th>Lote</th>
                    <th>Estoque</th>
                  </thead>
                  <tbody v-for="estoque in estoques" :key="estoque.id">
                    <tr>
                      <td class="text-center">{{ material.nome }}</td>
                      <td class="text-center">
                        {{ estoque.fabricante.nome_fantasia }}
                      </td>
                      <td class="text-center">{{ estoque.lote }}</td>
                      <td class="text-center">{{ estoque.quantidade }}</td>
                    </tr>

                    <tr v-if="isLastOfMaterial(estoque)">
                      <td colspan="3" class="text-center font-weight-bold">
                        <strong>Total:</strong>
                      </td>
                      <td class="text-center font-weight-bold">
                        <strong> {{ getTotal(estoque.material_id) }} </strong>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    class="col-md-12 text-center p-1"
                    style="border: 1px solid #ccc; border-radius: 8px"
                    v-if="!estoques.length"
                  >
                    <td class="p1" colspan="4">Não há estoques</td>
                  </tbody>
                </table>
              </div>

              <div class="col-md-12 text-right">
                <hr />
                <router-link to="/materiais" class="btn btn-back mr-1">
                  <i class="fa fa-arrow-left" />
                  Voltar
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      material: {
        controlado: 0,
        portaria: 0,
      },
      tipo_receitas: [],
      grupos: [],
      sub_grupos: [],
      familias: [],
      fabricantes: [],
      fornecedores: [],
      grupos: [],
      unidadeMateriais: [],
      estoques: [],
    };
  },
  computed: {},
  methods: {
    isLastOfMaterial(estoque) {
      const index = this.estoques.indexOf(estoque);
      return (
        index === this.estoques.length - 1 ||
        this.estoques[index + 1].material_id !== estoque.material_id
      );
    },

    getTotal(materialId) {
      return this.estoques
        .filter((estoque) => estoque.material_id === materialId)
        .reduce((total, estoque) => total + estoque.quantidade, 0);
    },
    _getMaterial: function (id) {
      const self = this;
      const api = self.$store.state.api + "materiais/" + id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.material = response.data.data[0];
          self.loadSubGrupos();
          self.loadFamilias();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    get getMaterial() {
      return this._getMaterial;
    },
    set getMaterial(value) {
      this._getMaterial = value;
    },
    getTipoReceitas: function () {
      const self = this;
      const api = self.$store.state.api + "tipo_receitas";

      axios
        .get(api)
        .then((response) => {
          self.tipo_receitas = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getGrupos: function () {
      const self = this;
      const api = self.$store.state.api + "grupos";

      axios
        .get(api)
        .then((response) => {
          self.grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSubGrupos: function () {
      const self = this;
      const api =
        self.$store.state.api + "sub_grupos?grupo_id=" + self.material.grupo_id;

      self.material.subgrupo_id = null;
      self.material.familia_id = null;
      self.sub_grupos = [];
      self.familias = [];

      axios
        .get(api)
        .then((response) => {
          self.sub_grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFamilias: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "familias?subgrupo_id=" +
        self.material.subgrupo_id;

      self.material.familia_id = null;
      self.familias = [];

      axios
        .get(api)
        .then((response) => {
          self.familias = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEstoques: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "estoques?material_id=" +
        id +
        "&with[]=fabricante";

      self.material.id = null;
      self.estoques = [];

      axios
        .get(api)
        .then((response) => {
          self.estoques = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    loadSubGrupos: function () {
      const self = this;
      const api =
        self.$store.state.api + "sub_grupos?grupo_id=" + self.material.grupo_id;

      axios
        .get(api)
        .then((response) => {
          self.sub_grupos = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    loadFamilias: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "familias?subgrupo_id=" +
        self.material.subgrupo_id;

      axios
        .get(api)
        .then((response) => {
          self.familias = response.data.data;

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getFabricantes: function () {
      const self = this;
      const api = self.$store.state.api + "fabricantes";

      axios
        .get(api)
        .then((response) => {
          self.fabricantes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFornecedores: function () {
      const self = this;
      const api = self.$store.state.api + "fornecedores";

      axios
        .get(api)
        .then((response) => {
          self.fornecedores = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUnidadeMateriais: function () {
      const self = this;
      const api = self.$store.state.api + "unidade_materiais";

      axios
        .get(api)
        .then((response) => {
          self.unidadeMateriais = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  mounted: function () {
    const self = this;

    self.getTipoReceitas();
    self.getGrupos();
    self.getFabricantes();
    self.getFornecedores();
    self.getUnidadeMateriais();

    $("#material").focus();

    let id = self.$route.params.id;
    if (id) {
      self.getMaterial(id);
      self.getEstoques(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
</style>